import React, { Component } from 'react';
import { LenderRow } from '../components/LenderRow.tsx';
import { MortgageReason } from '../helpers/Enums.js';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { HomeSvg } from '../svg/HomeSvg.tsx';
import { faWeight } from '@fortawesome/free-solid-svg-icons';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
    showPrev: boolean;
}

export class Purchaser extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1>Let's get you home!<br/>{/* First up, what stage are you at?</h1> */}When are you looking to buy?</h1>                
                <p>Our experts help home buyers at every stage of their journey, <strong>at no cost to you</strong></p>
                <div className='wrapper'>
                    <div className='row mt-2'>
                        <div className='column3'>
                            {/* <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.Researching.toString())}> */}
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.zerotosixmonths.toString())}>
                                <div>
                                    {/* <div><i className='fa fa-binoculars s30' /></div> */}
                                    <div><span className='boxheader'>Soon!</span></div>
                                    <div><span className='b'>0-6 months</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column3'>
                            {/* <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.MortgageApproval.toString())}> */}
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.sixtotwelvemonths.toString())}>
                                <div>
                                    {/* <div><i className='fa fa-map s30' /></div>
                                    <div><span className='b'>I'd like mortgage approval</span></div> */}
                                    <div><span className='boxheader'>Later</span></div>
                                    <div><span className='b'>6-12 months</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column3'>
                            {/* <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.FoundHome.toString())}> */}
                            <div className='boxty' onClick={() => this.props.nextStep(MortgageReason.twelveplusmonths.toString())}>
                                <div>
                                    {/* <div><HomeSvg/></div>
                                    <div><span className='b'>I've had an offer accepted</span></div> */}
                                    <div><span className='boxheader'>12+ Months</span></div>
                                    <div><span className='b'>I'm just researching</span></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.showPrev &&
                        <div className='row'>
                            <div className='button-group'>
                                <PreviousButton onClick={() => this.props.prevStep()} />
                            </div>
                        </div>
                    }
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header >
        );
    }
}
